<template lang="pug">
main.modal-wrapper
    svg-icon.close-modal.cursor(name='close' size="small" @click.native="closeModal()")

    main.modal-main

        header.modal-header
            sectionHeader(:title="formActionText")

            ul.tabs.l-flex-row
                li.tab(
                    :class="{'is-active': formSegment.activeTab === 'information'}"
                    @click="setTab('information')")
                    div.tab-label Information
                li.tab(
                    :class="{'is-active': formSegment.activeTab === 'frequency'}"
                    @click="setTab('frequency')" v-if="accountWithFrequency")
                    div.tab-label Frequency

        div.modal-body

            //- TAB DETAILS - INFORMATION
            template(v-if="formSegment.activeTab === 'information'")

                //- LABEL
                div.form-section.mg-tp-24
                    div.form-subsection
                        div.form-label__required
                            label(for="label") Label
                        input.form-input(
                            v-model="segmentInfo.label"
                            placeholder="label"
                            autofocus
                            id="label"
                            name="label"
                            v-validate="'max:200|required'"
                            type="text")
                        span.form-validate-error {{ errors.first('label') }}

                    div.l-flex-row.has-gutter_medium
                        div.form-subsection.w-180
                            div.form-label__required
                                label(for="category") Category
                            input.form-input(
                                v-model="segmentCategory"
                                placeholder="category"
                                autofocus
                                id="category"
                                name="category"
                                v-validate="'max:255|required'"
                                type="text"
                                :class="{'ui-disabled': disableEditCategory}")
                            span.form-validate-error {{ errors.first('category') }}
                            span.form-validate-error(v-if="showSegmentCategoryError") Only ASCII characters without "_"

                        div.form-subsection.w-180
                            div.form-label__required
                                label(for="identifier") Identifier
                            input.form-input(
                                v-model="segmentCustomId"
                                placeholder="identifier"
                                autofocus
                                id="identifier"
                                name="identifier"
                                v-validate="'max:255|numeric|min_value:1|required'"
                                type="text"
                                :class="{'ui-disabled': disableEditCategory}")
                            span.form-validate-error {{ errors.first('identifier') }}

                //- div.form-section.section-cclone-mode(v-if="isWamFactoActivated")
                div.form-section(v-if="isWamFactoActivated")
                    //- RULE
                    div.section-title Rule
                    div.form-section
                        div.form-subsection
                            div.form-label
                                label(for="rule") Rule
                            textarea(
                                placeholder="Define a new rule"
                                v-model="rule"
                                id="rule"
                                :class="{ 'ui-disabled': ['pending', 'processing'].includes(this.segmentInfo._initial_boostrap_status) && !this.segmentInfo.isNew }"
                                name="rule"
                            )
                            span.form-validate-error(v-if="isRuleValid === false") This rule is not valid
                            span(v-if="segmentInfo.bootstrap_status === 'processing'") Boostrap processing ...
                        div.l-flex-row.has-gutter_medium.rule-estimation-wrapper
                            div.form-subsection.w-180
                                div.estimate-rule.l-flex-row--between.l-align-center(v-if="ruleEstimationValidated && estimateFeature")
                                    button.btn-form.is-highlight.btn-estimate-rule(
                                        :class="{'is-disabled': disableEstimationButton }"
                                        @click="estimateRule()"
                                    ) Estimate rule
                            div.form-subsection.w-180
                                div.uu-reached.l-flex-row--rev.l-align-center(v-if="displayRuleEstimation") {{ ruleEstimation }} users reached
                                spinner.l-flex-row--rev.l-align-center(v-else-if="isLoading" width="20" height="20")

                        //- NAMESPACE
                        div.form-subsection
                            div.form-label
                                label(for="namespace") Namespace
                            select.form-select.big(
                                id="namespace"
                                name="namespace"
                                :class="{'ui-disabled': disableNamespace }"
                                v-model="segmentInfo.rule.namespace_id")
                                option(
                                    v-for="item in namespaces",
                                    :key="item.id",
                                    :label="item.label",
                                    :value="item.id") {{ item.label }}

                        div.form-section
                            div.form-section--switch.l-flex-row--between(:class="{'is-disabled': rule === '' }")
                                div.form-label.l-flex-row.flex-1
                                    label.flex-1(for="switch-activate-rule") Activate rule
                                div.onoffswitch
                                    input(
                                        id="switch-activate-rule"
                                        name="switch-activate-rule"
                                        class="onoffswitch-checkbox"
                                        type="checkbox"
                                        v-model="segmentInfo.rule.status"
                                        :true-value="'active'"
                                        :false-value="'inactive'"
                                        unchecked
                                    )
                                    label(class="onoffswitch-label" for="switch-activate-rule")

                        div.form-section(v-if="bootstrapCSAvailable")
                            div(v-if="bootstrapIsRunning")
                                div.form-label.flex-1
                                    p.flex-1 Segment already bootstraped or is running
                            div(v-else).form-section--switch.l-flex-row--between(:class="{'is-disabled': disableBootstrap }")
                                div.form-label.flex-1
                                    label.flex-1(for="switch-bootstrap")
                                        div Bootstrap segment
                                        div.form-section-subtitle.form-section-subtitle--bootstrap Bootstrap on segment is made on 30 days period
                                            br
                                            |  and can be activated only once.
                                div.onoffswitch
                                    input(
                                        id="switch-bootstrap"
                                        name="switch-bootstrap"
                                        class="onoffswitch-checkbox"
                                        type="checkbox"
                                        v-model="currentBoostrapStatus"
                                        :true-value="checkBoxTrueValue"
                                        false-value="unavailable"
                                        unchecked
                                    )
                                    label(class="onoffswitch-label" for="switch-bootstrap")

            //- TAB DETAILS - FREQUENCY
            template(v-if="formSegment.activeTab === 'frequency' && accountWithFrequency")
                div.form-segment-content.mg-tp-24

                    div.form-information-message Set periods on which frequency will be calculated (max. 5 periods).

                    div.form-subsection.form-section-frequency.l-flex-column(
                        v-for="(frequency, index) of orderedFrequencies" :key="index"
                    )
                        div.period-info.l-flex-row--between(v-if="!frequency.isNew")
                            div.period-values.l-flex-row Period from
                                |
                                div.value_from -{{ frequency.period_from }}
                                | days to
                                div.value_to -{{ frequency.period_to }}
                                | days
                        div.period-wrapper
                            div.l-flex-row--center
                                el-slider(
                                    v-model="frequency.input"
                                    class='frequency-slider'
                                    :disabled="!frequency.isNew"
                                    @change="checkNewPeriod($event, index)"
                                    range
                                    :max="0"
                                    :min="-30"
                                    :marks="marks")
                                svg-icon.cursor(
                                    name='trash' size='medium'
                                    class="icon-delete-frequency"
                                    title="remove this frequency"
                                    @click.native="deletePeriod(index)"
                                )
                        div.form-section.form-section---bootstrap--top-margin(v-if="accountWithFrequency")
                            //- div.form-section---bootstrap.l-flex-row--between(:class="{'is-disabled': (!frequency.isNew && frequency.bootstrap_status !=='unavailable')}")
                            div.form-section---bootstrap.l-flex-row--between(:class="{'is-disabled': isDisabledFrequencyBootstrap(frequency)}")
                                div.form-label
                                    div.form-section-subtitle.form-section-subtitle--bootstrap Bootstrap frequency
                                div.onoffswitch
                                    input(
                                        :id="'switch-bootstrap-frequency' + index"
                                        :name="'switch-bootstrap-frequency' + index"
                                        class="onoffswitch-checkbox"
                                        type="checkbox"
                                        v-model="frequency.bootstrap_status"
                                        :true-value="frequencyBootstrapTrueValue(frequency.bootstrap_status)"
                                        false-value="unavailable"
                                        unchecked
                                    )
                                    label(class="onoffswitch-label" :for="'switch-bootstrap-frequency'+ index")

                    p.l-flex-row--center.new-frequency-disclaimer(v-if="checkPeriodIsUnique") A period must be unique
                    div.flex-1.l-flex-row--center.l-align-center.btn-new-frequency(:class="{'ui-disabled': smartSegmentCount > 200}" v-if="checkTotalPeriods && !checkPeriodIsUnique" @click="addPeriod()") Add a new period
                    span.form-validate-error.flex-1.l-flex-row--center.l-align-center(v-if="smartSegmentCount > 200") The limit of 200 frequency has been reached

        //- FOOTER
        footer.modal-footer
            div.footer-content.l-flex-row--between
                button.btn.btn--medium.btn--round(@click="closeModal()") Cancel
                button.btn.btn--medium.btn--round.btn-rev(:class="{'is-disabled': disableSaveForm}" @click="saveForm()") {{ formActionText }}

</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { cloneDeep, debounce, get, head, uniqWith, isEmpty, isEqual, isNil, last, map, split, toNumber, toString, orderBy, find, reduce } from 'lodash'

import dayjs from 'dayjs'

import { SEGMENT_FORM_DATATABS } from '@/utils/constants'

import SectionHeader from '@/components/common/SectionHeader'

export default {
    name: 'SegmentForm',

    components: { SectionHeader },

    props: { segment: { required: true, type: Object } },

    mounted() {
        // This is used to make sure we can't update segment's bootstra when it as already been activated
        if (this.formSegment.type === 'update') {
            this.segmentCategory = last(split(this.segmentInfo.key, '_'))
            this.segmentCustomId = head(split(this.segmentInfo.key, '_'))
            if (get(this.segment, 'rule.rule')) {
                this.setIsRuleValid({ isValid: true })
            }
        }
        if (!this.segment.rule || !find(this.namespaceIds, id => id === this.segment.rule.namespace_id)) {
            this.segmentInfo.rule.namespace_id = this.segmentInfo?.historyRule?.namespace_id || this.defaultNamespaceId
        }
    },

    watch: {
        rule: function(newValue, oldValue) {
            if (isEmpty(newValue)) {
                this.setIsRuleValid({ isValid: null })
                this.segmentInfo.rule.status = 'inactive'
            } else {
                if (!isEqual(newValue, oldValue) && typeof this.ruleEstimation === 'number') {
                    this.setRuleEstimation({ estimation: '-', segmentId: 'cs_creation' })
                }
            }
            this.debouncedCheckRule(newValue)
        },
        isRuleValid: function(newVal, oldVal) {
            if (!isEqual(newVal, oldVal) && newVal !== true) {
                this.segmentInfo.bootstrap_status = 'unavailable'
            }
            // Enable edit in the case where a segment was saved and trying to edit the rule but it was blocked
            if (newVal && this.segmentInfo.isSaved && this.segmentInfo.bootstrap_status === 'unavailable') {
                this.segmentInfo.isSaved = false
            }
        },
        segmentCategory: function(newVal, oldVal) {
            if (!isEqual(newVal, oldVal)) {
                if (!isEmpty(newVal)) {
                    const asciiCode = newVal.charCodeAt(newVal.length - 1)
                    if (asciiCode === 95 || asciiCode > 126) {
                        this.showSegmentCategoryError = true
                    } else {
                        this.showSegmentCategoryError = false
                    }
                } else {
                    this.showSegmentCategoryError = false
                }
            }
        },
        segmentInfo: {
            handler: function(val) {
                // deactivate switch of deactivating rule
                this.setSegmentBootstrapAlreadyActivated({
                    taxo: this.selectedTaxoId,
                    id: this.segmentInfo.id,
                    value: !['unavailable', 'pending'].includes(this.segmentInfo.bootstrap_status)
                })

                if (this.bootstrapIsRunning) {
                    return
                }

                if (val.rule.status !== 'active') {
                    this.currentBoostrapStatus = 'unavailable'
                    this.segmentInfo.bootstrap_status = 'unavailable'
                }

                // Enable edit in the case where a segment was saved and trying to edit the rule but it was blocked
                // if (val.rule.status === 'active' && this.segmentInfo.isSaved && this.segmentInfo.bootstrap_status === 'unavailable') {
                //     this.segmentInfo.isSaved = false
                // }
            },
            deep: true
        }
    },

    data() {
        return {
            dataTabs: SEGMENT_FORM_DATATABS,
            rule: get(this.segment, 'rule.rule', ''),
            segmentCategory: '',
            segmentCustomId: toString(dayjs().unix()),
            noZeroDay: true,
            currentBoostrapStatus: `${this.segment.bootstrap_status}`,
            segmentInfo: {
                ...this.segment,
                rule: this.segment.rule ? cloneDeep(this.segment.rule) : { namespace_id: '', status: 'inactive', rule: '', cs_id: null },
                smart_segments: isEmpty(this.segment.smart_segments)
                    ? []
                    : cloneDeep(
                        map(this.segment.smart_segments, smartSegment => {
                            const from = this.convertToNumber(smartSegment.period_from)
                            const to = this.convertToNumber(smartSegment.period_to)
                            return {
                                ...smartSegment,
                                input: [from, to]
                            }
                        })
                    )
            },
            marks: {
                '-30': {
                    style: {
                        opacity: '0.5',
                        'font-size': '10px'
                    },
                    label: '-30 days'
                },
                0: {
                    style: {
                        opacity: '0.5',
                        'font-size': '10px'
                    },
                    label: 'Now'
                }
            },
            showSegmentCategoryError: false,
            checkPeriodIsUnique: false,
            processing: false
        }
    },

    computed: {
        bootstrapIsRunning() {
            if (this.segmentInfo.isNew) {
                return false
            }

            if (!['processing', 'pending', 'done'].includes(this.segmentInfo._initial_boostrap_status)) {
                return false
            }

            if (this.segmentInfo.isSaved) {
                return this.segmentInfo._initial_boostrap_status !== 'unavailable'
            }

            if (!this.segmentInfo.isSaved) {
                if (this.segmentInfo._initial_boostrap_status === 'unavailable') {
                    return false
                }
                return true
            }

            if (!this.segmentInfo.isNew && !this.segmentInfo.isSaved && this.segmentInfo._initial_boostrap_status !== 'unavailable') {
                return true
            }

            return false
        },
        ...mapState('data/settings', {
            accountWithFrequency: state => state.general.frequency
        }),

        ...mapState('ui/settings', {
            estimateFeature: state => state.wamFactory.estimation
        }),

        ...mapState('ui/manageTaxonomy', {
            displayModal: state => state.formSegment.displayModal,
            formSegment: state => state.formSegment,
            selectedSegmentId: state => state.selectedSegmentId,
            isRuleValid: state => state.isRuleValid,
            ruleEstimations: state => state.ruleEstimations,
            isLoading: state => state.isLoading.rule,
            hierarchies: state => state.hierarchies,
            selectedTaxoId: state => state.selectedTaxoId,
            newCSParentId: state => state.newCSParentId,
            newCSSiblings: state => state.newCSSiblings,
            arrayCreatedSegmentKeys: state => state.createdSegmentKeys
        }),

        ...mapState('account', {
            isWamFactoActivated: state => state.settings.wam_factory_activated,
            bootstrapCSAvailable: state => state.settings.bootstrap_custom_segment_available,
            ruleEstimationValidated: state => state.settings.ruleActivated,
            namespaces: state => state.namespaces,
            defaultNamespaceId: state => state.defaultNamespaceId
        }),

        ...mapGetters('ui/manageTaxonomy', ['getSmartSegmentCount']),

        formActionText() {
            const fatxt = this.formSegment.type === 'update' ? 'edit' : this.formSegment.type
            return `${fatxt} segment`
        },

        disableCreate() {
            return (
                isEmpty(this.segmentInfo.label) ||
                isEmpty(this.segmentCategory) ||
                isEmpty(this.segmentCustomId) ||
                this.showSegmentCategoryError ||
                (!this.isRuleValid && this.rule !== '')
            )
        },

        namespaceIds() {
            return this.namespaces.map(nm => nm.id)
        },

        disableNamespace() {
            return this.isRuleValid !== true || (this.disableEditCategory && get(this.segment, 'historyRule.rule', '') !== '')
        },

        boostrapInUse() {
            // bootstrap_status | enum('unavailable','pending','processing','done','failed')
            return this.formSegment.type !== 'create' && ['processing', 'pending', 'done'].includes(this.segmentInfo.bootstrap_status)
        },

        disableBootstrap() {
            if (this.bootstrapIsRunning) {
                return true
            }

            if (
                this.isRuleValid === true &&
                this.segmentInfo.rule.status === 'active' &&
                !this.segmentInfo.bootstrapAlreadyActivated
            ) {
                return false
            }

            return (
                this.isRuleValid !== true ||
                this.segmentInfo.rule.status !== 'active' ||
                this.boostrapInUse
            )
        },

        disableEstimationButton() {
            return !this.ruleEstimationValidated || !this.isRuleValid || isEmpty(this.segmentInfo.label) || typeof this.ruleEstimation === 'number'
        },

        ruleEstimation() {
            return get(this.ruleEstimations, 'cs_creation', '-')
        },

        // Frequency
        orderedFrequencies() {
            return orderBy(this.segmentInfo.smart_segments, 'created_at')
        },

        checkTotalPeriods() {
            return this.segmentInfo.smart_segments && this.segmentInfo.smart_segments.length < 5
        },

        smartSegmentCount() {
            return this.getSmartSegmentCount()
        },

        disableSaveForm() {
            if (this.formSegment.type === 'update') return this.commonDisable || !this.hasChanges
            return this.commonDisable
        },

        previousItemRule() {
            const previous = this.segment?.rule?.rule
            return previous || ''
        },

        previousItemStatus() {
            const previous = this.segment?.rule?.status
            return previous || 'inactive'
        },

        smartSegmentLength() {
            const smartSegment = this.segment?.smart_segments
            return smartSegment ? smartSegment.length : 0
        },

        hasChanges() {
            const previousItem = cloneDeep(this.segment)
            previousItem.bootstrap_status = this.currentBoostrapStatus
            let smartSegmentsBootstrapStatusChanged = false
            if (previousItem.smart_segments) {
                previousItem.smart_segments.forEach(el => {
                    const similar = this.segmentInfo.smart_segments.find(seg => +seg.wam_custom_segment_id === +el.wam_custom_segment_id)
                    if (similar && (similar.bootstrap_status !== el.bootstrap_status)) smartSegmentsBootstrapStatusChanged = true
                })
            }

            return (
                this.segmentInfo.label !== previousItem.label ||
                this.segmentInfo.bootstrap_status !== previousItem.bootstrap_status ||
                this.rule !== this.previousItemRule ||
                this.segmentInfo.rule.status !== this.previousItemStatus ||
                this.segmentInfo.smart_segments.length !== this.smartSegmentLength ||
                smartSegmentsBootstrapStatusChanged
            )
        },

        commonDisable() {
            return this.errors.items.length > 0 || this.processing || this.disableCreate || this.checkPeriodIsUnique || !this.noZeroDay
        },

        checkBoxTrueValue() {
            // We need to do this to make sure, the checkbox consider these values as truthy, as we have several ones
            if (this.segmentInfo.bootstrap_status === 'done') {
                return 'done'
            } else if (this.segmentInfo.bootstrap_status === 'pending') {
                return 'pending'
            }
            return 'pending'
        },

        disableEditCategory() {
            return this.formSegment.type === 'update' && !this.arrayCreatedSegmentKeys.some(i => i === this.selectedSegmentId)
        },

        displayRuleEstimation() {
            return this.ruleEstimation !== '-' && !this.isLoading
        }
    },

    methods: {
        // Call to mutations
        ...mapMutations('ui/manageTaxonomy', [
            'setSegmentForm',
            'setIsRuleValid',
            'setRuleEstimation',
            'setNewCSParentId',
            'setNewCSSiblings',
            'setSegmentBootstrapAlreadyActivated'
        ]),
        ...mapActions('ui/manageTaxonomy', ['checkId', 'updateCustomSegment', 'checkRuleValidation', 'retrieveRuleEstimation', 'createCustomSegment']),
        ...mapMutations('notifications', ['setAddedNotification']),

        frequencyBootstrapTrueValue(status) {
            return status !== 'unavailable' ? status : 'pending'
        },

        checkNewPeriod() {
            const frequencyInputs = this.orderedFrequencies.map(freq => freq.input)
            const accu = true
            this.noZeroDay = reduce(
                frequencyInputs,
                (chec, freq) => {
                    return this.checkPeriod(freq) && chec
                },
                accu
            )
            const sameFreq = uniqWith(frequencyInputs, isEqual)
            if (frequencyInputs.length !== sameFreq.length) {
                this.checkPeriodIsUnique = true
            } else {
                this.checkPeriodIsUnique = false
            }
        },
        checkPeriod(inputs) {
            return inputs[0] !== inputs[1]
        },

        closeModal() {
            this.processing = false
            this.currentBoostrapStatus = 'unavailable'
            this.setNewCSParentId({ id: null })
            this.setNewCSSiblings({ siblings: [] })
            this.setSegmentForm({
                displayModal: false,
                type: 'create',
                activeTab: 'information'
            })
            this.setRuleEstimation({ estimation: '-', segmentId: 'cs_creation' })
            this.setIsRuleValid({ isValid: null })
        },

        // Frequency
        addPeriod() {
            this.segmentInfo.smart_segments.push({
                isNew: true,
                input: [-30, 0],
                wam_custom_segment_id: this.segment.id,
                bootstrap_status: 'unavailable'
            })
            this.checkNewPeriod()
        },

        deletePeriod(orderedIndex) {
            let listIndex = null
            for (const index in this.segmentInfo.smart_segments) {
                if (isEqual(this.segmentInfo.smart_segments[index].input, this.orderedFrequencies[orderedIndex].input)) {
                    listIndex = index
                }
            }
            if (listIndex !== null) this.segmentInfo.smart_segments.splice(listIndex, 1)
            this.checkNewPeriod()
        },

        convertToNumber(string) {
            return toNumber(string) * -1
        },

        // RULE
        estimateRule() {
            this.retrieveRuleEstimation({ rule: this.rule, segmentId: 'cs_creation' })
        },

        debouncedCheckRule: debounce(function(rule) {
            if (!isEmpty(rule)) this.checkRule(rule)
        }, 200),

        checkRule(rule) {
            this.checkRuleValidation({ rule })
        },

        saveForm() {
            if (this.processing) return // Prevent multiple creation
            this.processing = true
            if (this.formSegment.type === 'create') {
                this.checkId({ cs_id: this.segmentCustomId, cs_category: this.segmentCategory }).then(response => {
                    if (!isNil(response)) {
                        if (response === 0) {
                            this.segmentInfo.parent_id = this.newCSParentId
                            this.segmentInfo.key = this.segmentCustomId + '_' + this.segmentCategory
                            this.segmentInfo.action = 'create'
                            this.segmentInfo.isSaved = false
                            this.segmentInfo.isNew = true
                            this.segmentInfo.id = this.segmentInfo.key
                            this.segmentInfo.bootstrap_status = this.currentBoostrapStatus

                            // Frequency
                            this.segmentInfo.smart_segments = map(this.segmentInfo.smart_segments, ss => {
                                // delete ss.isNew // OSEF ? L'API n'en tient pas compte
                                return {
                                    ...ss,
                                    period_from: toString(Math.abs(ss.input[0])),
                                    period_to: toString(Math.abs(ss.input[1]))
                                }
                            })

                            // Rule
                            if (isEmpty(this.rule)) {
                                delete this.segmentInfo.rule
                            } else {
                                this.segmentInfo.rule.rule = this.rule
                            }

                            // Hierarchy
                            const items = isNil(this.newCSParentId) ? cloneDeep(this.hierarchies[this.selectedTaxoId]) : cloneDeep(this.newCSSiblings)
                            items.unshift(this.segmentInfo)

                            this.createCustomSegment({
                                parentId: this.newCSParentId,
                                key: this.segmentInfo.key,
                                items
                            })
                            this.closeModal()
                        } else {
                            this.setAddedNotification({ type: 'error', message: 'Element already exists for this custom segment type' })
                        }
                    }
                })
            } else if (this.formSegment.type === 'update') {
                this.segment.isSaved = false
                const item = {
                    ...this.segment,
                    label: this.segmentInfo.label,
                    key: this.segmentCustomId + '_' + this.segmentCategory,
                    rule: { ...this.segmentInfo.rule, rule: this.rule },
                    bootstrap_status: this.currentBoostrapStatus,
                    smart_segments: map(this.segmentInfo.smart_segments, ss => {
                        // delete ss.isNew // OSEF ? L'API n'en tient pas compte
                        return {
                            ...ss,
                            period_from: toString(Math.abs(ss.input[0])),
                            period_to: toString(Math.abs(ss.input[1]))
                        }
                    })
                }
                if (isEmpty(this.rule)) {
                    item.rule.action = 'delete'
                }
                if (!this.$store.state.account.settings.wam_factory_activated) {
                    delete item.rule
                }
                this.updateCustomSegment({
                    action: this.formSegment.type,
                    item,
                    canEditKey: !this.disableEditCategory
                })
                this.closeModal()
            }
        },
        isDisabledFrequencyBootstrap(frequency) {
            if (!frequency.isNew && frequency.initialBootstrapStatus !== 'unavailable') return true
            return false
        },

        // Tabs
        setTab(selectedTab) {
            this.setSegmentForm({
                displayModal: this.formSegment.displayModal,
                type: this.formSegment.type,
                activeTab: selectedTab
            })
        }
    }
}
</script>
